<template>
  <div id="app">
    <NavBar/>
    <router-view :key="$route.fullPath"/>
    <div id="loading">Loading&#8230;</div>
    <el-dialog id="dlgGoToApp" title="Warning" :modal="true" width="50%">
      <span slot="footer" class="dialog-footer">
        <span>Please log in or create an itinerary before coming to this page</span>
        <br>
        <br>
        <el-button type="primary">Go back to App</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/NavBar';

@Component({
  components: {
    NavBar,
  },
})
export default class App extends Vue {
}
</script>

<style lang="scss">
@import '@/assets/main.scss';


</style>
